import * as React from "react";
import { BusinessReportOutcome } from "@/modules/snapshots/businessReports.types";
import { GridSidebarSearchHeader } from "./header";
import { GridSidebarSearchRow } from "./row";
import { motion, AnimatePresence } from "framer-motion";

interface Props {
  snapshotCollectionOutcomes: BusinessReportOutcome[];
}

export const GridSidebarSearchResults: React.FC<Props> = ({ snapshotCollectionOutcomes }) => (
  <div className="overflow-hidden ring-1 ring-[#d2cac0] sm:rounded-lg">
    <table className="w-full divide-y divide-gray-300">
      <GridSidebarSearchHeader total={snapshotCollectionOutcomes.length} />
      <tbody className="divide-y divide-gray-200 bg-white">
        <AnimatePresence mode="popLayout">
          {snapshotCollectionOutcomes.map((businessReportOutcome, index) => (
            <motion.tr
              key={businessReportOutcome.id}
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{
                duration: 0.3,
                delay: index * 0.05, // Stagger rows slightly
              }}
            >
              <GridSidebarSearchRow businessReportOutcome={businessReportOutcome} />
            </motion.tr>
          ))}
        </AnimatePresence>
      </tbody>
    </table>
  </div>
);
